<template>
	<core-layout-content full>
		<core-layout-headline-and-actions>
			<template slot="headline">
				{{ $t("commission_rules") }}
				<core-pagination-info
					:itemsPerPage="itemsPerPage"
					:numberOfItems="listing.numberOfItems"
					:currentPage="page"
				/>
			</template>
			<template slot="actions">
				<j-button :to="{ name: 'CommissionsCreate' }">
					<crm-icon name="add" size="small" color="c5" />
					{{ $t("create_rule") }}
				</j-button>
			</template>
		</core-layout-headline-and-actions>

		<!-- Search -->
		<!-- <div class="flex wrap xs-12 xs-left mb2">     
      <div class="flex xs-12">
        <j-base-input-search
          :placeholder="$t('search_id')"
          :value="searchTerm"
          @input="onSearch($event)"  />	
        <j-button
          class="ml2"
          type="tertiary"
          v-if="searchTerm"
          @click="cancelSearch">
          {{$t('cancel')}}
        </j-button>
      </div>
    </div> -->

		<!-- Data Container -->
		<j-card class="bg5">
			<j-data-table
				:header="header"
				:list="computedList"
				:sortable="false"
				:isLoading="isLoading"
				@sort="onSort($event)"
			>
				<template slot="list" slot-scope="{ item }">
					<td v-for="(column, i) in header" :key="i">
						<template>
							<!-- Actions -->
							<template v-if="column.field === 'actions'"> </template>

							<!-- Name -->
							<template v-else-if="column.field === 'name'">
								<!-- <router-link :to="`create-update/${item.id}`" :append="true">{{item.name ? item.name : "---"}}</router-link> -->
								<span class="c2">{{ item.name ? item.name : "---" }}</span>
							</template>

							<!-- Others -->
							<template v-else>
								{{ item[column.field] }}
							</template>
						</template>
					</td>
				</template>
				<template slot="empty">
					{{ $t("errors.no_data") }}
				</template>
			</j-data-table>
		</j-card>

		<!-- Pagination -->
		<div class="flex xs-12 p4 xs-center mb15">
			<j-pagination
				:amount="listing.numberOfItems"
				:perPage="itemsPerPage"
				:activePage="page"
				@click="onPageChange($event)"
			/>
		</div>
	</core-layout-content>
</template>

<script>
import CrmIcon from "@/components/CrmIcon/"
import JButton from "@/components/JButton/"
import JCard from "@/components/JCard/"
import JDataTable from "@/components/JDataTable/"
import JBaseInputSearch from "@/components/JBaseInputSearch/"
import JPagination from "@/components/JPagination/"
import CorePaginationInfo from "@/modules/core/components/CorePaginationInfo"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions"
import dayjs from "dayjs"
import api from "../api/"
import get from "lodash.get"

export default {
	components: {
		CrmIcon,
		JButton,
		JCard,
		JDataTable,
		JBaseInputSearch,
		JPagination,
		CorePaginationInfo,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions
	},

	data() {
		return {
			isLoading: false,

			// Actual fetched data
			listing: {
				numberOfItems: 0,
				list: []
			},

			// Search term
			searchTerm: null,

			// Pagination
			page: 1,
			itemsPerPage: 30,

			// Header of table
			header: [
				{
					field: "name",
					text: this.$t("name")
				},
				{
					field: "product",
					text: this.$t("product")
				},
				{
					field: "description",
					text: this.$t("description")
				},
				{
					text: this.$t("created_by"),
					field: "createdBy"
				},
				{
					text: this.$t("created"),
					field: "createdAt"
				}
			]
		}
	},

	computed: {
		computedList() {
			return this.listing.list.map(item => ({
				...item,
				product: get(item, "product.name"),
				createdBy: get(item, "createdBy.associatedUser.name"),
				createdAt: item.createdAt
					? dayjs(item.createdAt).format(
							this.$store.state.settings.dateTimeFormat
					  )
					: null
			}))
		}
	},

	methods: {
		onPageChange(pageIndex) {
			this.page = pageIndex
			this.fetchCommisionRules()
			this.scrollToTop()
		},

		scrollToTop() {
			this.$scrollTo("body", 300)
		},

		onSearch(value) {
			const payload = value === null || value === "" ? null : value
			this.searchTerm = value
			this.page = 1
			this.fetchCommisionRules()
		},

		cancelSearch() {
			this.searchTerm = null
			this.page = 1
			this.onSearch()
		},

		async fetchCommisionRules() {
			// Sort by date
			let sort = { fieldName: "createdAt", type: "desc" }

			// Pagination
			const skip = (this.page - 1) * this.itemsPerPage
			const limit = this.itemsPerPage

			// Search
			let where = null
			if (this.searchTerm)
				where = {
					// id: `/${this.searchTerm}/gi`
					id: this.searchTerm
				}

			this.isLoading = true
			const res = await api.commissionRules({ where, sort, skip, limit })
			this.isLoading = false

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				this.listing.list = []
			}

			this.listing.list = res.data.commissionRules.list
			this.listing.numberOfItems = res.data.commissionRules.totalCount
		}
	},

	mounted() {
		this.fetchCommisionRules()
	}
}
</script>
